module.exports = __webpack_public_path__ + "img/order.7c5c24bd.svg";